import {BANNER_URL} from "../../helpers/api.routes";
import {requests} from "../../helpers/api.services";
import {IPagination} from "../../shared/interface";
import {IZone} from "./interface";

export const AdminBannerService = {
    getAll: (params: IPagination) => requests.get(`${BANNER_URL}`, params),
    update: (params: FormData, id: number) => requests.post(`${BANNER_URL}/${id}`, params, true),
    create: (params: FormData) => requests.post(`${BANNER_URL}`, params, true),
    getSingle: (id: number) => requests.get(`${BANNER_URL}/${id}`),
    delete: (id: number) => requests.delete(`${BANNER_URL}/${id}`),
    getAllZone: (params: IPagination) => requests.get(`${BANNER_URL}-zone`, params),
    updateZone: (params: IZone) => requests.put(`${BANNER_URL}-zone/${params.id}`, params),
    createZone: (params: IZone) => requests.post(`${BANNER_URL}-zone`, params, true),
    getSingleZone: (id: number) => requests.get(`${BANNER_URL}-zone/${id}`),
    deleteZone: (id: number) => requests.delete(`${BANNER_URL}-zone/${id}`),
};
